import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import { store } from './store/store';

import 'bootstrap';
import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);

import { VueSpinners } from '@saeris/vue-spinners';
Vue.use(VueSpinners);

import Snotify, { SnotifyPosition } from 'vue-snotify';
import 'vue-snotify/styles/material.css';

const options = {
  toast: {
    timeout: 2500,
    position: SnotifyPosition.rightTop,
  },
};

Vue.use(Snotify, options);

import element from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
Vue.use(element, { locale });

import underscore from 'vue-underscore';
Vue.use(underscore);

Vue.use(require('vue-moment'));

import 'chart.js';
import VueCharts from 'hchs-vue-charts';
Vue.use(VueCharts);

import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);

import Vuelidate from 'vuelidate';
import Notifications from 'vue-notification';
import UUID from 'vue-uuid';
import Swal from 'vue-sweetalert2';

import VueAgile from 'vue-agile';
Vue.use(VueAgile);

import moment from 'moment-timezone';
moment.tz.setDefault('Europe/London');

// import VueCarousel from 'vue-carousel';
// Vue.use(VueCarousel);

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

Vue.use(window.VueCharts);
Vue.use(Vuelidate);
Vue.use(Notifications);
Vue.use(UUID);
Vue.use(Swal);

import VueSlideoutPanel from 'vue2-slideout-panel';
Vue.use(VueSlideoutPanel);

import StatusIndicator from 'vue-status-indicator';
Vue.use(StatusIndicator);

import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';

Vue.config.productionTip = false;

global.$ = global.jQuery = require('jquery');

var base64js = require('base64-js');
Vue.use(base64js);

import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);

import VueApexCharts from 'vue-apexcharts';
Vue.component('apexchart', VueApexCharts);

import VueMq from 'vue-mq';
Vue.use(VueMq, {
  breakpoints: {
    mobile: 600,
    tablet: 900,
    desktop: Infinity,
  },
});

import Switches from 'vue-switches';
Vue.component('switches', Switches);

import './assets/styles/styles.css';

$.getJSON('/appsettings.json', function(json) {
  Vue.config.honeycomb = json;
  Vue.prototype.$config = { honeycomb: json };
  Vue.prototype.$config.honeycomb.HHNHHMappings = {
    'Unrestricted': 'HH Unrestricted',
    '2-Rate': 'HH E7 0730',
    '3-Rate': 'HH 5D 7NEW',
    'HH Vanilla Profile': 'HH LPO Vanilla',
    'HH Banana Profile': 'HH LPO Banana',
    'HH 3-Rate': 'HH LPO DISCONTINUED',
    'HH 2-Rate': 'HH E7 0700',
    'Heavy Peak User': 'HH LPO Heavy Peak',
  };
  // require(`./assets/styles/themes/${json.theme}.scss`)
  document.documentElement.style.setProperty('--primary', json.theme);
  // There's an example of the permissions function in use in MeterPointSummary for adding a reading
  Vue.mixin({
    methods: {
      hasPermission(area, mask, expectedOutput) {
        var index = this.$_.findWhere(this.$store.state.permissionAreas, {
          Name: area,
        }).Id;
        var byte = base64js.toByteArray(this.$auth.decodedToken.payload.perm)[
          index
        ];
        return (byte & parseInt(mask, 2)) === expectedOutput;
      },
      wordSplit: function(word) {
        var foo = '';
        var splitWord = word.toString().split(/(?=[A-Z0-9])/);
        for (let i = 0; i < splitWord.length; i++) {
          foo += splitWord[i] + ' ';
        }
        return foo;
      },
    },
  });
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
});
